<h1 mat-dialog-title>Error Detail</h1>
<div mat-dialog-content>
    <div class="fields">
        <div class="field">
            <span class="title">Date</span>
            <span class="value">{{ errorLog?.dateString | date: 'dd-MM-yyyy hh:mm' }}</span>
        </div>
        <div class="field">
            <span class="title">Type</span>
            <span class="value">{{ errorLog?.errorType }}</span>
        </div>
        <div class="field">
            <span class="title">Error</span>
            <span class="value">{{ errorLog?.errorMessage }}</span>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>Close</button>
</div>
